import { getLogger } from "@goodgamestudios/logger";
import { Localize } from "../utils/Localize";

const logger = getLogger("LocalizationJS.CurrencyFormatter");
export class CurrencyFormatter {
    public static localize = null;

    /**
     * HTML5 not supported
     */
    public readonly actualLocaleIDName: string;
    /**
     * HTML5 not supported
     */
    public readonly decimalSeparator: string;
    /**
     * HTML5 not supported
     */
    public digitsType: number;
    /**
     * HTML5 not supported
     */
    public fractionalDigits: number;
    /**
     * HTML5 not supported
     */
    public groupingPattern: string;
    /**
     * HTML5 not supported
     */
    public groupingSeparator: string;
    /**
     * HTML5 not supported
     */
    public readonly lastOperationStatus: string;
    /**
     * HTML5 not supported
     */
    public leadingZero: boolean;
    /**
     * HTML5 not supported
     */
    public negativeCurrencyFormat: number;
    /**
     * HTML5 not supported
     */
    public negativeSymbol: string;
    /**
     * HTML5 not supported
     */
    public positiveCurrencyFormat: number;
    /**
     * HTML5 not supported
     */
    public readonly requestedLocaleIDName: string;
    /**
     * HTML5 not supported
     */
    public trailingZeros: boolean;
    /**
     * HTML5 not supported
     */
    public useGrouping: boolean;

    private _currencyISOCode: string;
    private _currencySymbol: string;

    /**
     * !!! This class is only made for EM, it's not what it should be from AS3.
     * Currently all formaters use a singleton Globolize.currencyFormatter from Localize.service,
     * because in EM they are making a new formatter everytime they want to format a price, which is not performance efficient.
     * @param requestedLocaleIDName This parameter serves nothing at the moment, we use default globalize lang settings.
     */
    constructor(requestedLocaleIDName: string) {
        this.requestedLocaleIDName = requestedLocaleIDName;
        if (!CurrencyFormatter.localize) {
            CurrencyFormatter.localize = Localize;
        }
    }

    public get currencyISOCode(): string {
        return this._currencyISOCode;
    }

    public get currencySymbol(): string {
        return this._currencySymbol;
    }

    /**
     * Format the price.
     * @param value number of price to format
     * @param withCurrencySymbol not used, for EM this is alwasy true
     */
    public format(value: number, withCurrencySymbol: boolean = false): string {
        return CurrencyFormatter.localize.formatCurrency(value, withCurrencySymbol);
    }

    /**
     * Update the currency code and symbol for localize service.
     * @param currencyISOCode 3-letter currency code
     * @param currencySymbol this parameter is not used it's different from `currencyISOCode`, we depends on the localiza.service
     * to find the correct symbol; if this parameter is the same as ISOcode, we won't show currency symbol but show the currencyCode
     * directly.
     */
    public setCurrency(currencyISOCode: string, currencySymbol: string): void {
        this._currencyISOCode = currencyISOCode;
        this._currencySymbol = currencySymbol;
        CurrencyFormatter.localize.updateCurrencyFormatter(currencyISOCode, currencySymbol);
    }

    /**
     * NOT implemented
     * @param requestedISOCode 3-letter currency code
     */
    public formattingWithCurrencySymbolIsSafe(requestedISOCode: string): boolean {
        logger.warn(`formattingWithCurrencySymbolIsSafe is not surpported`);
        return false;
    }

    /**
     * NOT implemented
     */
    public getAvailableLocaleIDNames(): string[] {
        logger.warn(`getAvailableLocaleIDNames is not surpported`);
        return [];
    }

    /**
     * NOT implemented
     * @param input string to parse
     */
    public parse(input: string): {currencyString: string, value: number} {
        logger.warn(`parse is not supported`);
        return {currencyString: "", value: 0};
    }
}
